var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"ax-list-item",class:{
    'ax-list-item--divider-top': _vm.dividerTop,
    'ax-list-item--divider-bottom': _vm.dividerBottom
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }